/**
 * Mirrors backend `internal/training/catalog.ts` category ids + labels.
 */

export const TRAINING_CATEGORIES = [
  {
    id: "employee-onboarding",
    label: "Employee Onboarding",
    description:
      "Agency welcome, credentials, and day-one platform workflows for staff.",
  },
  {
    id: "patient-onboarding",
    label: "Patient Onboarding",
    description:
      "Charts, admission documents, evaluations, and first-visit readiness.",
  },
  {
    id: "billing",
    label: "Billing",
    description:
      "Authorizations, claims, ledgers, and office billing workflows.",
  },
  {
    id: "libraries",
    label: "Libraries",
    description:
      "Physicians, pharmacies, payers, facilities, and care-plan templates.",
  },
];

export const TRAINING_SORT_OPTIONS = [
  { id: "newest", label: "Date added (newest)" },
  { id: "oldest", label: "Date added (oldest)" },
  { id: "title", label: "Title (A–Z)" },
  { id: "category", label: "Category" },
];

export function youtubeThumbnailUrl(youtubeId) {
  if (!youtubeId) return "";
  return `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;
}

export function formatTrainingDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });
}

/** Relative stamp for card footers — e.g. "3 hours ago". */
export function formatRelativeUpdated(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";

  const diffMs = Date.now() - d.getTime();
  if (diffMs < 0) return "just now";

  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} minute${mins === 1 ? "" : "s"} ago`;

  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} day${days === 1 ? "" : "s"} ago`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months === 1 ? "" : "s"} ago`;

  const years = Math.floor(days / 365);
  return `${years} year${years === 1 ? "" : "s"} ago`;
}

/** Category accent tokens for cover gradients / pills (Kornivus indigo family). */
export function categoryAccent(categoryId) {
  switch (categoryId) {
    case "employee-onboarding":
      return {
        gradient: "from-indigo-600/95 via-violet-600/90 to-fuchsia-700/85",
        pill: "bg-indigo-950/55",
        avatar: "bg-indigo-600",
      };
    case "patient-onboarding":
      return {
        gradient: "from-sky-600/95 via-indigo-600/90 to-violet-700/85",
        pill: "bg-sky-950/55",
        avatar: "bg-sky-600",
      };
    case "billing":
      return {
        gradient: "from-violet-600/95 via-indigo-700/90 to-slate-800/85",
        pill: "bg-violet-950/55",
        avatar: "bg-violet-600",
      };
    case "libraries":
      return {
        gradient: "from-slate-700/95 via-indigo-700/90 to-indigo-900/85",
        pill: "bg-slate-950/55",
        avatar: "bg-slate-700",
      };
    default:
      return {
        gradient: "from-indigo-600/95 via-violet-600/90 to-indigo-900/85",
        pill: "bg-slate-950/55",
        avatar: "bg-indigo-600",
      };
  }
}
